import { AdvertiserInsertionOrderCollection } from '@features/users/adminPanel/services/advertiserInsertionOrders/service.types.ts';
import { AdvertisersCollection } from '@features/users/adminPanel/types/advertisers.types.ts';

export function transformAdvertiserInsertionOrdersResponseDTO(
  response: AdvertiserInsertionOrderCollection,
): AdvertisersCollection {
  return response.map(({ id, companyName, vatNumber, invoicingEmail, status }) => ({
    id,
    name: companyName,
    vatNumber,
    invoicingEmail,
    status,
  }));
}
